import { useSelector } from "react-redux";
import TimeByStatusCards from "./component/timeByStatusCards";
import TimeByUnitCards from "./component";
import { listPerformanceTimeKPIByStore, summaryTimeKPI } from "./helper";
import { isLoading } from "../component/loading/store";
import React, { useState } from "react";
import { Skeleton } from "@mui/material";
import useTrademarkFilter from "../../hooks/useTrademarkFilter";

export default function PerfomanceOperation() {
    const kpiPermormanceTime = useSelector((state) => state.kpiPerformanceTimeBySatus)
    const loadingPerformanceTime = useSelector((state) => isLoading(state, 'KPI_PERFORMANCE_TIME_STATUS'))

    // faz o filtro das listas de performance time por marca selecionada pelo usuário
    const filteredKpiPermormanceTime = useTrademarkFilter(kpiPermormanceTime)

    const cardPerformanceTimeSummaryKPI = summaryTimeKPI(filteredKpiPermormanceTime)
    const cardPerformanceTimeKPIByStore = listPerformanceTimeKPIByStore(filteredKpiPermormanceTime)
    const [expanded, setExpanded] = useState({})

    const toggleExpand = (idUnidade) => {
        setExpanded((prev) => ({
            ...prev,
            [idUnidade]: !prev[idUnidade]
        }))
    }

    return (
        <>
            {!loadingPerformanceTime ?
                <>
                    <TimeByStatusCards
                        summary={cardPerformanceTimeSummaryKPI}
                        valueFormatter={(v) => v ?? '—'}
                        tooltipMap={{
                            tempoConfirmacao: 'Tempo entre a data do pedido e data de confirmação',
                            tempoProducao: 'Tempo entre a data de confirmação até a data de retirada ou saida para entrega',
                            tempoEntrega: 'Tempo entre a saida e entrega',
                            tempoTotal: 'Tempo total do ciclo do pedido',
                        }}
                    />

                    <TimeByUnitCards
                        units={cardPerformanceTimeKPIByStore}
                        expanded={expanded}
                        onToggleExpand={toggleExpand}
                    />
                </>
                :
                <>
                    <div className="gap-6 mt-6">
                        <Skeleton variant="rounded" height={150} />
                    </div>
                </>

            }
        </>
    )
}